module.exports = __webpack_public_path__ + "static/digital_strategy-fa1940b9ff8d08e3416cc59942636401.jpg";